import { useLocation } from 'react-router-dom';
import {
  PortalRootWrapper,
  PortalRootBody,
  BodyAndSidebarWrapper,
} from "./Styles";

import { Outlet } from "react-router-dom";
import { Sidebar } from "../Sidebar";

import { HeaderMobile } from "../HeaderMobile";
import { SubscriptionModal } from "../Sidebar/SubscriptionModal";
import { MiniChatWidget } from "../MiniChatWidget";
import { TourHost } from "../Tour";
import { eventBus } from "../../Common/EventBus";
import { useState, useEffect } from "react";
import { registerServiceWorker } from "../../Common/PushNotifications/registerServiceWorker";
import { usePushMessageListener } from "../../Common/PushNotifications/usePushMessageListener";

const PortalRootContent = () => {
  const location = useLocation();
  const isContractDetail = /^\/contracts\/[^/]+$/.test(location.pathname);
  const hasSubSidebar = location.pathname === "/" || location.pathname.startsWith("/chat") || isContractDetail;
  const isChatView = location.pathname === "/" || location.pathname.startsWith("/chat");
  const [showSubscriptionModal, setShowSubscriptionModal] = useState(false);

  // Register service worker on mount
  useEffect(() => {
    registerServiceWorker();
  }, []);

  // Listen for push messages from service worker
  usePushMessageListener();

  useEffect(() => {
    const handleOpenSubscriptionModal = () => {
      setShowSubscriptionModal(true);
    };

    eventBus.on("OPEN_SUBSCRIPTION_MODAL", handleOpenSubscriptionModal);

    return () => {
      eventBus.off("OPEN_SUBSCRIPTION_MODAL", handleOpenSubscriptionModal);
    };
  }, []);

  return (
    <PortalRootWrapper>
      <BodyAndSidebarWrapper $hasSubSidebar={hasSubSidebar} $isChatView={isChatView}>
        <Sidebar />
        <HeaderMobile />
        <PortalRootBody $isChatView={isChatView}>
          <Outlet />
        </PortalRootBody>
      </BodyAndSidebarWrapper>

      {showSubscriptionModal && (
        <SubscriptionModal onClose={() => setShowSubscriptionModal(false)} />
      )}

      <MiniChatWidget />
      <TourHost />
    </PortalRootWrapper>
  );
};

export const PortalRoot = () => {
  return <PortalRootContent />;
};
